export default {
    items: [
        {
            id: 'navigation',
            title: '目錄',
            titleEN: 'Catalogue',
            type: 'group',
            icon: 'icon-support',
            children: [
                {
                    id: 'dashboard',
                    title: '概覽',
                    titleEN: 'Overview',
                    type: 'item',
                    url: '/dashboard',
                    classes: 'nav-item',
                    icon: 'fas fa-th-large',
                    color: 'info'
                },
                {
                    id: 'healthDashboard',
                    title: '健康',
                    titleEN: 'Health',
                    type: 'item',
                    url: '/healthDashboard',
                    classes: 'nav-item',
                    icon: 'fas fa-hand-holding-heart',
                    color: 'orange'
                },
                {
                    id: 'event',
                    title: '活動',
                    titleEN: 'Event',
                    type: 'item',
                    url: '/event',
                    classes: 'nav-item',
                    icon: 'fas fa-table-tennis',
                    color: 'primary'
                },
                {
                    id: 'profile',
                    title: '我的簡歷',
                    titleEN: 'My Diary',
                    type: 'item',
                    url: '/profile',
                    classes: 'nav-item',
                    icon: 'fas fa-user-alt',
                    color: 'success'
                },
                {
                    id: 'logout',
                    title: '登出',
                    titleEN: 'Logout',
                    type: 'item',
                    url: '/login',
                    classes: 'nav-item',
                    icon: 'fas fa-door-open'
                }
            ]
        }
    ]
}